<template>
  <div v-loading.fullscreen.lock="fullscreenLoading" id="dscroll" class="m-scrollable--track m-scroller ps ps--active-y"
    data-scrollable="true" style="overflow: hidden;">
    <div class="m-portlet m-portlet--mobile">
      <PageHead label='出科考核场次设置' label2="新增禁用场次" url="/system/outapply/examtimemanage"></PageHead>
      <el-form class="m-form m-form--fit m-form--label-align-right m-form--group-seperator-dashed" :model="form" ref="form">
        <div class="m-portlet__body">
          <div class="form-group m-form__group row">
            <label class="col-lg-1 col-form-label">禁用日期：</label>
            <div class="col-lg-3">
              <el-date-picker v-model="form.examdate" type="date" placeholder="禁用日期" style="width: 100%;" value-format="yyyy/MM/dd"></el-date-picker>
            </div>
          </div>
          <div class="form-group m-form__group row">
            <label class="col-lg-1 col-form-label">禁用场次：</label>
            <div class="col-lg-3">
              <el-checkbox-group v-model="form.examtime">
                <div v-for="item in examtimeOptions" :key="item.DictItemID">
                  <el-checkbox :label="item.DictItemID" border style="width: 100%;">{{item.DictItemName}}</el-checkbox>
                </div>
              </el-checkbox-group>
            </div>
          </div>
          <div class="m-portlet__foot m-portlet__no-border m-portlet__foot--fit">
            <div class="m-form__actions m-form__actions--solid">
              <div class="row">
                <div class="col-lg-12" style="text-align: center;">
                  <el-button type="success" icon="el-icon-s-order" @click="Add()" v-loading.fullscreen.lock="fullscreenLoading">保存</el-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'OutAdd',
    data() {
      return {
        form: {
          token: '',
          username: '',
          rolelevel: '',
          examdate: '',
          examtime: []
        },
        examtimeOptions: [],
        fullscreenLoading: false
      }
    },
    methods: {
      Add: function() {
        if (this.form.examdate == '') {
          this.$message({
            message: '请选择禁用日期',
            type: 'warning'
          })
          return
        }
        if (this.form.examtime == '') {
          this.$message({
            message: '请选择禁用场次',
            type: 'warning'
          })
          return
        }

        this.fullscreenLoading = true
        var that = this
        this.$http.post(this.$utils.Url.zpgl + '/api/APICyclePlan/AddExamTimeDisabled', this.form)
          .then(res => {
            if (res.data.Code === 0) {
              that.$message({
                message: '保存成功',
                type: 'success'
              })
              console.log('保存成功')
              that.$router.push('/main/system/outapply/examtimemanage')
            } else {
              that.$message({
                message: res.data.Msg + '，' + res.data.Data,
                type: 'error'
              })
            }
            that.fullscreenLoading = false
          })
          .catch(err => {
            console.log(err)
            that.$message({
              message: '保存失败',
              type: 'error'
            })
            that.fullscreenLoading = false
          })
      },
      LoadExamTimeList: function() {
        var that = this
        var args = {
          token: this.form.token
        }
        this.$utils.HttpPost(this.$utils.Url.zpgl + '/api/APICyclePlan/LoadExamTimeList', args, function(data) {
          that.examtimeOptions = data.Data
        }, null, null, null)
      }
    },
    mounted: function() {
      this.form.token = sessionStorage.getItem('token')
      this.form.username = sessionStorage.getItem('username')
      this.form.rolelevel = sessionStorage.getItem('rolelevel')
      this.LoadExamTimeList()
    }
  }
</script>

<style>
</style>
